import { CUT_CATEGORY_WINDING_GROUP } from '@/constants/new-order';
import { ValidateModelStrategy } from '@/utils/validation';
import { getStorageByKey, setStorageValueByKey } from './localStorage';
import { MODEL_OPTIONS } from '@/constants/variables';

export const isCategoryWindingType = (category, type) => {
  const find = CUT_CATEGORY_WINDING_GROUP[type]?.find(({ id }) => id === category.id);

  return Boolean(find);
};

export const getOptionValues = ({ list, valueObj, isChangeSizeHeight }) => {
  const resultObj = list.reduce((acc, value) => {
    const optionValue = valueObj[value.code_1c];

    if (optionValue) {
      if (!value.option_default || isChangeSizeHeight) {
        acc = {
          ...acc,
          [value.id]: optionValue,
        };
      }
    }

    return acc;
  }, {});

  return resultObj;
};

const getOptionDefault = (list = [], itemId = null) => {
  if (!list?.length || !itemId) {
    return null;
  }

  const itemFind = list.find(({ id }) => id === itemId);
  if (itemFind) {
    return itemFind.id;
  }

  const notFind = list.find(({ name }) => name.toLowerCase() === 'нет');
  if (notFind) {
    return notFind.id;
  }

  return list[0].id;
};

const getOptionsValuesFilter = (list = []) => (regexp, isNotRegexp = false) =>
  list.filter(
    ({ name }) =>
      name.toLowerCase() === 'нет' || (isNotRegexp ? !name?.match(regexp) : name?.match(regexp)),
  );

export const getOrderFilterOptions = ({ list = [], model = null }) => {
  if (model?.name?.toLowerCase() === 'карниз для римских штор') {
    const upperCorniceFind = list.find(({ name }) => name.toLowerCase() === 'верхний карниз');
    const electricalKitFind = list.find(({ name }) => name.toLowerCase() === 'комплект электрики');

    if (upperCorniceFind && electricalKitFind) {
      const upperCorniceSelected = upperCorniceFind.options_values?.find(
        ({ id }) => id === upperCorniceFind.option_default,
      );
      const upperCorniceSelectedName = upperCorniceSelected?.name;

      const electricKitId = electricalKitFind.id;
      const electriclKitOptions = electricalKitFind.options_values;
      const electricKitDefault = electricalKitFind.option_default;
      const optionsValuesFilter = getOptionsValuesFilter(electriclKitOptions);
      if (upperCorniceSelectedName?.match(/MIDI/)) {
        //eslint-disable-next-line
        const options_values = optionsValuesFilter(/(MAXI)|(MINI)/, true);
        const electriclKit = {
          ...electricalKitFind,
          option_default: getOptionDefault(options_values, electricKitDefault),
          options_values,
        };
        const newList = list.map(item => {
          if (item.id === electricKitId) {
            return {
              ...item,
              options_values: electriclKit.options_values,
            };
          }

          return item;
        });

        return { list: newList, electriclKit };
      }

      if (upperCorniceSelectedName === 'MAXI') {
        const options_values = optionsValuesFilter(/MAXI/);
        const electriclKit = {
          ...electricalKitFind,
          option_default: getOptionDefault(options_values, electricKitDefault),
          options_values,
        };
        const newList = list.map(item => {
          if (item.id === electricKitId) {
            return {
              ...item,
              options_values: electriclKit.options_values,
            };
          }

          return item;
        });

        return { list: newList, electriclKit };
      }

      if (upperCorniceSelectedName === 'MINI') {
        const options_values = optionsValuesFilter(/MINI/);
        const electriclKit = {
          ...electricalKitFind,
          option_default: getOptionDefault(options_values, electricKitDefault),
          options_values,
        };
        const newList = list.map(item => {
          if (item.id === electricKitId) {
            return {
              ...item,
              options_values: electriclKit.options_values,
            };
          }

          return item;
        });

        return { list: newList, electriclKit };
      }

      // if (upperCorniceSelectedName === 'День-Ночь MIDI') {
      //   //eslint-disable-next-line
      //   const options_values = optionsValuesFilter(/д\/\н/);

      //   const electriclKit = {
      //     ...electricalKitFind,
      //     option_default: getOptionDefault(options_values, electricKitDefault),
      //     options_values,
      //   };

      //   const newList = list.map(item => {
      //     if (item.id === electricKitId) {
      //       return {
      //         ...item,
      //         options_values: electriclKit.options_values,
      //       };
      //     }

      //     return item;
      //   });

      //   return { list: newList, electriclKit };
      // }
    }
  }

  return { list, electriclKit: null };
};

const hasItemOption = ({ tube = null, electrikKit = null }) => {
  const item = tube || electrikKit;
  if (!item) {
    return;
  }
  const defaultId = item.option_default;
  const find = item.options_values.find(
    ({ id, name = '' }) => id === defaultId && name.toLowerCase() !== 'нет',
  );

  if (tube && find && !find.electrikKit?.startsWith('Привод DM')) {
    return;
  }

  return find;
};

export const getUpdateElektrikDrive = ({
  option,
  value,
  system,
  model,
  elektrikDrive,
  tube,
  electrikKit,
}) => {
  if (elektrikDrive && system?.name?.toLowerCase() === 'рулонные шторы') {
    const isModeZipOrLock = model?.name?.match(/(ZIP)|(LOCK)/i);
    if (isModeZipOrLock) {
      const elektrikDriveValueFind = elektrikDrive?.options_values?.find(
        ({ name = '' }) => name.toLowerCase() === 'да',
      );

      if (!elektrikDriveValueFind) {
        return null;
      }

      const isOptionTube =
        tube && option?.code_1c === tube.code_1c && value?.name?.startsWith('Привод DM');
      const isOptionElectrikKit =
        electrikKit &&
        option?.code_1c === electrikKit.code_1c &&
        value?.name?.toLowerCase() !== 'нет';

      if (isOptionTube || hasItemOption({ electrikKit })) {
        return {
          value: elektrikDriveValueFind.id,
          code_1c: elektrikDrive.code_1c,
        };
      }

      if (isOptionElectrikKit || hasItemOption({ tube })) {
        return {
          value: elektrikDriveValueFind.id,
          code_1c: elektrikDrive.code_1c,
        };
      }

      const notFind = elektrikDrive?.options_values?.find(
        ({ name = '' }) => name.toLowerCase() === 'нет',
      );

      if (notFind) {
        return {
          value: notFind.id,
          code_1c: elektrikDrive.code_1c,
        };
      }
    }
  }

  return null;
};

export const getIsHideHeightForOrder = ({ system = null, model = null }) => {
  const modelStrategy = new ValidateModelStrategy(model);
  // для roman высоту выводим - это исключение для карнизов
  const isRoman = system?.name?.toLowerCase() === 'римские шторы';

  // price_type = 2 - это за За погонный метр
  if (model?.price_type === 2 && modelStrategy.isCornice()) {
    return !isRoman;
  }

  return false;
};

const keyStorageNewOrderPrices = 'new-order-prices';
export const storageNewOrderPrices = {
  get: () => getStorageByKey(keyStorageNewOrderPrices),
  set: value => setStorageValueByKey(keyStorageNewOrderPrices, value),
  remove: () => localStorage.removeItem(keyStorageNewOrderPrices),
};

// определение общих св-во в "кастомайзе" и в "новый заказа поставщику"
export const getCurrentOrderData = ({ preData = null }) => {
  if (!preData) {
    return preData;
  }

  const hasElectricDrive = preData?.parameters?.options?.find(
    ({ vendor_code = '', value = '' }) =>
      vendor_code === MODEL_OPTIONS.ELECTRIC_DRIVE.vendor_code &&
      value.toLowerCase() === 'да',
  );

  return {
    ...preData,
    ...(preData.parameters && {
      parameters: {
        ...preData.parameters,
        electric_drive: hasElectricDrive ? 1 : 0,
      },
    }),
  };
};
